import React, { useRef } from 'react';
import './LogoTooltip.scss';
import { createPopper } from '@popperjs/core';
import contents from '../../contents';
import logo from '../../assets/awsIntelLogo.svg';

function LogoTooltip({ comp }) {
  const tooltipRef = useRef();
  const handleMouseEnterLogo = (e) => {
    const content = tooltipRef.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  const handleMouseLeaveLogo = () => {
    const content = tooltipRef.current;
    content.style.visibility = 'hidden';
  };

  return (
    <>
      {/* <a href={contents.logoTooltip.href} target="_blank" rel="noreferrer"> */}
      {/* Import your logo at the top of this file and change the src below */}
      <img
        className={`logo logo--${comp}`}
        src={logo}
        alt="Logo"
        onMouseEnter={(e) => {
          handleMouseEnterLogo(e);
        }}
        onMouseLeave={handleMouseLeaveLogo}
      />
      {/* </a> */}
      <div className="tooltip" ref={tooltipRef}>
        <p className="tooltip__text">{contents.logoTooltip.copy}</p>
      </div>
    </>
  );
}

export default LogoTooltip;
